/**
 * Returns true if two arrays have at least one common element.  Otherwise, returns false.
 * @param a
 * @param b
 */
export function intersect<T>(a: T[], b: T[]): boolean {
  return a.filter(element => b.includes(element)).length > 0;
}
